/* (ignored) */


//////////////////
// WEBPACK FOOTER
// got (ignored)
// module id = 1300
// module chunks = 0